export default __webpack_public_path__ + "static/media/splash.3130c044.png";